import clsx from 'clsx';
import { MagazineContextProvider } from '../../../../contexts/Magazine/Magazine.context';
import Container from '../../Container/Container';
import { ContainerChildrenSpace, ContainerSize } from '../../Container/consts';
import MagazineTeaserArticle from '../MagazineTeaserArticle/MagazineTeaserArticle';
import styles from './MagazineRelatedArticles.module.scss';
import {
  MagazineRelatedArticlesItem,
  MagazineRelatedArticlesProps,
} from './interfaces';

const MagazineRelatedArticles = ({
  title = 'Verwandte Artikel',
  subTitle = 'Diese Themen könnten Sie auch interessieren.',
  items = [],
}: MagazineRelatedArticlesProps) => {
  const _items: MagazineRelatedArticlesItem[] = items.filter(
    (item): item is MagazineRelatedArticlesItem => typeof item !== 'undefined'
  );

  return (
    <div className={styles.base}>
      <Container spaceBetweenChildren={ContainerChildrenSpace.Micro}>
        <Container size={ContainerSize.Small}>
          <div className={styles.headline}>
            <h3 className={styles.title}>{title}</h3>
            <p className={styles.subTitle}>{subTitle}</p>
          </div>
        </Container>
        <div className={styles.list}>
          {_items.map(
            (
              {
                path,
                id,
                title,
                subTitle,
                image,
                description,
                category = '',
                tags,
              },
              index
            ) => {
              return (
                <MagazineContextProvider
                  value={{ currentCategory: category }}
                  key={`${id}-${index}`}
                >
                  <div
                    className={clsx({
                      [styles.hideTablet]: index === _items.length - 1,
                    })}
                  >
                    <MagazineTeaserArticle
                      title={title}
                      subTitle={subTitle}
                      description={description}
                      image={image}
                      variant={'small'}
                      path={path}
                      category={category}
                      tags={tags}
                    />
                  </div>
                </MagazineContextProvider>
              );
            }
          )}
        </div>
      </Container>
    </div>
  );
};

export default MagazineRelatedArticles;
